import { createLogger } from "../../helper/logger";
import { getAPI } from "../services/api-services";

const logger = createLogger("RequestAPIServices");
const baseURL = process.env.REACT_APP_API;
const isFakeAuth =
	process.env.REACT_APP_AUTH_FAKE_IT === "YES" ||
	process.env.REACT_APP_AUTH_FAKE_IT === "TRUE";

// Mock data for different job types
const mockCaseRequestData = {
	WEDGE: [
		{
			wbID: "WB-2025-0001",
			caseID: "CASE-2025-001",
			accountName: "Mock Insurance Co.",
			assignedTo: "Developer User",
			status: "Open",
			dateCreated: "2025-05-01",
			dateCompleted: null,
		},
		{
			wbID: "WB-2025-0002",
			caseID: "CASE-2025-002",
			accountName: "Test Company Inc.",
			assignedTo: "Developer User",
			status: "In-Progress",
			dateCreated: "2025-05-03",
			dateCompleted: null,
		},
	],
	GAP: [
		{
			wbID: "GAP-2025-0001",
			caseID: "CASE-2025-003",
			accountName: "Mock Financial Services",
			assignedTo: "Developer User",
			status: "Open",
			dateCreated: "2025-05-04",
			dateCompleted: null,
		},
	],
};

export const getCaseRequest = async (jobType, token = "") => {
	// Return mock data when auth is faked
	if (isFakeAuth) {
		logger.debug("Using mock data for getCaseRequest", { jobType });

		// Return appropriate mock data based on job type
		const mockData = mockCaseRequestData[jobType] || [];

		return {
			data: mockData,
			loading: false,
			error: null,
		};
	}

	// Real API call when not in mock mode
	const url = `${baseURL}/api/getAllCaseID/?jobType=${jobType}`;
	const { data, loading, error } = await getAPI(url, token);
	return { data, error, loading };
};
